import React, { useContext, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import axios from 'axios';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { SearchBox } from 'components/form/prototypes';
import { Asterisk } from 'components/form/prototypes';

const CustNumberSearch = () => {
  const { state, setState, setToasts } = useContext(NCRContext);
  const { user } = useContext(UserContext);
  const { register } = useFormContext();
  const [loading, setLoading] = useState(false);

  const isDisabled = ['QA', 'GM'].includes(user.role)
    ? state.ncr.status.id > 2
    : state.ncr.status.id > 1;

  const setSODetails = (so) => {
    setState((prev) => ({
      ...prev,
      ncr: {
        ...prev.ncr,
        original_customer_number: so?.so_customer_number,
        customer_name: so?.customer_name,
        internal_customer_id: so?.Customer_Internal_ID,
        sales_order_internal_id: so?.Sales_Order_Internal_ID,
        original_warehouse: so?.shipping_warehouse,
        original_so_date: so?.so_date,
        order: {
          ...prev.ncr.order,
          shipping_instructions: so?.shipping_instructions,
          address: {
            ...prev.ncr.order.address,
            address_line_1: so?.address_line_1,
            address_line_2: so?.address_line_2,
            address_city: so?.city,
            address_country: so?.country,
            address_postcode: so?.postcode,
            address_code: so?.Ship_toCountry_RegionCode,
          },
          contact: {
            ...prev.ncr.order.contact,
            contact_name: so?.contact_name,
            contact_number: so?.contact_number,
          },
        },
        return: {
          ...prev.ncr.return,
          shipping_instructions: so?.shipping_instructions,
          customer_name: so?.customer_name,
          address: {
            ...prev.ncr.return.address,
            address_line_1: so?.address_line_1,
            address_line_2: so?.address_line_2,
            address_city: so?.city,
            address_country: so?.country,
            address_postcode: so?.postcode,
            address_code: so?.Ship_toCountry_RegionCode,
          },
          contact: {
            ...prev.ncr.return.contact,
            contact_name: so?.contact_name,
            contact_number: so?.contact_number,
          },
        },
      },
    }));
  };

  const getSalesOrder = (soNumber) => {
    if (!soNumber) {
      setToasts((toasts) => [
        ...toasts,
        {
          message: 'Please enter an SO number.',
          color: 'LightPink',
        },
      ]);
      setSODetails(null);
      return;
    }
    setLoading(true);
    axios
      .get(`/api/cust-view/${soNumber}`)
      .then((res) => {
        setSODetails(res.data);
      })
      .catch(() => {
        setToasts((toasts) => [
          ...toasts,
          {
            message: 'Account not found, please try again.',
            color: 'LightPink',
          },
        ]);
        setSODetails(null);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Asterisk />
      <SearchBox
        name="ncr.original_customer_number"
        label="Customer Number"
        placeholder="Enter a Customer number."
        disabled={isDisabled}
        getSalesOrder={getSalesOrder}
        setSODetails={setSODetails}
        ref={register({ required: true })}
        loading={loading}
      />
    </>
  );
};

export { CustNumberSearch };
